module.exports = __webpack_public_path__ + "img/filter_icon.fa8f8df8.svg";